import {
  debounce,
  t,
} from '@nova/utils'

class NovaCollectionPagination extends HTMLElement {
  constructor() {
    super()
    this.debouncedOnLoadMore = debounce(this.onLoadMoreHandler.bind(this), 500)
    this.position = this.dataset.position
    this.url = this.dataset.url
  }

  connectedCallback() {
    this.$loadMoreBtn = this.querySelector('.js-load-more')
    if (this.$loadMoreBtn) {
      this.$loadMoreBtn.addEventListener('click', this.debouncedOnLoadMore)
    }

    if (this.position === 'previous') {
      this.debouncedOnLoadMore()
    }
    this.updateViewProductsCount()
    this.restoreScrollItem()
  }

  onLoadMoreHandler(event) {
    let url = this.url
    if (event) {
      event.preventDefault()
      url = event.target.dataset.href
    }
    const sections = this.getSections()
      .map((section) => `sections[]=${section.section}`)
      .join('&')

    fetch(`${url}&${sections}`)
      .then((response) => response.json())
      .then((parsed) => {
        const html = Object.values(parsed).join('')
        this.renderProductGrid(html)
        if (this.position === 'next') {
          this.updateURLHash(url)
        }
      })
  }

  renderProductGrid(html) {
    const domHtml = new DOMParser()
      .parseFromString(html, 'text/html')
    const newProductGrid = domHtml.querySelector('.js-product-grid-list')
    const newPreviousLoadContainer = domHtml.querySelector('.js-load-previous-container')
    const newLoadMore = domHtml.querySelector('.js-load-more')
    const productGrid = document.querySelector('.js-product-grid-list')
    const previousLoadContainer = document.querySelector('.js-load-previous-container')

    let productCards = [...newProductGrid.querySelectorAll('nova-product-card')]
    if (this.position === 'previous') {
      productCards = productCards.reverse()
    }
    productCards.forEach(productCard => {
      const swatchesTemplate = newProductGrid.querySelector(
        `#async-swatches-json-${productCard.id}`,
      )
      const colorValuesTemplate = newProductGrid.querySelector(
        `#async-color-values-json-${productCard.id}`,
      )
      const sizesTemplate = newProductGrid.querySelector(
        `#async-sizes-json-${productCard.id}`,
      )
      const variantsTemplate = newProductGrid.querySelector(
        `#async-variants-json-${productCard.id}`,
      )
      const imagesTemplate = newProductGrid.querySelector(
        `#async-images-json-${productCard.id}`,
      )

      const swatches = swatchesTemplate
        ? JSON.parse(swatchesTemplate.content.textContent.trim())
        : []
      const colorValues = colorValuesTemplate
        ? JSON.parse(colorValuesTemplate.content.textContent.trim())
          : []
      const sizes = sizesTemplate
        ? JSON.parse(sizesTemplate.content.textContent.trim())
        : []
      const variants = variantsTemplate
        ? JSON.parse(variantsTemplate.content.textContent.trim())
        : []
      const images = imagesTemplate
        ? JSON.parse(imagesTemplate.content.textContent.trim())
        : []

      if (this.position === 'previous') {
        productGrid.insertBefore(productCard, productGrid.firstChild)
      } else {
        productGrid.appendChild(productCard)
      }

      productCard.swatches = swatches
      productCard.colorValues = colorValues
      productCard.sizes = sizes
      productCard.variants = variants
      productCard.images = images
    })

    this.updateViewProductsCount()

    if (this.$loadMoreBtn) {
      if (!newLoadMore) {
        this.$loadMoreBtn?.classList.add('hidden')
      } else {
        this.$loadMoreBtn.setAttribute('data-href', newLoadMore.dataset.href)
      }
    }

    if (this.position === 'previous') {
      previousLoadContainer.innerHTML = newPreviousLoadContainer.innerHTML
    }

    this.restoreScrollItem()
  }

  updateURLHash(url) {
    let params = new URLSearchParams(url.split('?')[1])
    params.delete('phcursor')
    params = params.toString()
    history.replaceState(
      {params},
      '',
      `?${params}`,
    )
  }

  restoreScrollItem() {
    const anchorId = location.hash
    if (!anchorId) return

    const productCardEl = document.querySelector(`[id="${anchorId.replace('#', '')}"]`)
    if (!productCardEl) return

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'

      document.addEventListener('beforeunload', () => {
        history.scrollRestoration = 'auto'
      })
    }

    setTimeout(() => {
      productCardEl.scrollIntoView({
        behavior: 'smooth',
      })
    }, 250)
  }

  updateViewProductsCount() {
    const productGrid = document.getElementById('main-collection-product-grid')
    const productCards = productGrid.querySelectorAll('nova-product-card')
    this.$viewProductsCountMarkers = document.querySelectorAll(
      '[data-view-products-count]',
    )

    this.$viewProductsCountMarkers.forEach(item => item.innerHTML = productCards.length)
  }

  getSections() {
    return [
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset
          .id,
      },
    ]
  }
}

customElements.define('nova-collection-pagination', NovaCollectionPagination)
